import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2 } from "lucide-react";

interface AuditEntry {
  id: string;
  entity_type: string;
  entity_id: string;
  action: string;
  changed_fields: string[] | null;
  new_value: any;
  changed_by_role: string | null;
  changed_at: string;
}

export const SafetyAuditLog = () => {
  const [entries, setEntries] = useState<AuditEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from("safety_instruction_audit_logs")
      .select("*")
      .order("changed_at", { ascending: false })
      .limit(200)
      .then(({ data }) => {
        setEntries((data as unknown as AuditEntry[]) || []);
        setLoading(false);
      });
  }, []);

  return (
    <Card>
      <CardHeader><CardTitle className="text-base">Audit-Log</CardTitle></CardHeader>
      <CardContent>
        {loading ? <div className="text-center py-8"><Loader2 className="h-6 w-6 animate-spin inline" /></div> : (
          <div className="border rounded-lg overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Zeitpunkt</TableHead>
                  <TableHead>Entität</TableHead>
                  <TableHead>Aktion</TableHead>
                  <TableHead>Geänderte Felder</TableHead>
                  <TableHead>Rolle</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {entries.length === 0 ? (
                  <TableRow><TableCell colSpan={5} className="text-center py-8 text-muted-foreground">Keine Einträge</TableCell></TableRow>
                ) : entries.map((e) => (
                  <TableRow key={e.id}>
                    <TableCell className="text-xs">{new Date(e.changed_at).toLocaleString("de-DE")}</TableCell>
                    <TableCell className="text-xs">{e.entity_type}</TableCell>
                    <TableCell><Badge variant="outline" className="text-xs">{e.action}</Badge></TableCell>
                    <TableCell className="text-xs">{e.changed_fields?.join(", ") || (e.new_value?.title || "–")}</TableCell>
                    <TableCell className="text-xs">{e.changed_by_role || "–"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
